import {
    CreateTimesheetPayload,
    CreateTimesheetResponse,
    DeleteTaskPayload,
    DeleteTaskResponse,
    ecsApi,
    GetTimesheetsReportsPayload,
    GetTimesheetsReportsResponse,
    GetTimesheetsTasksPayload,
    GetTimesheetsTasksResponse,
    UpdateTimesheetPayload,
    UpdateTimesheetResponse
} from '@services';

export const timesheetsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getTimesheetsReports: builder.mutation<GetTimesheetsReportsResponse, GetTimesheetsReportsPayload>({
            query: () => ({
                url: '/timesheets',
                method: 'GET'
            })
        }),
        getTimesheetsTasks: builder.mutation<GetTimesheetsTasksResponse, GetTimesheetsTasksPayload>({
            query: () => ({
                url: '/timesheets/tasks',
                method: 'GET'
            })
        }),
        createTimesheet: builder.mutation<CreateTimesheetResponse, CreateTimesheetPayload>({
            query: (body) => ({
                url: '/timesheets',
                method: 'POST',
                body
            })
        }),
        updateTimesheet: builder.mutation<UpdateTimesheetResponse, UpdateTimesheetPayload>({
            query: (body) => ({
                url: '/timesheets',
                method: 'POST',
                body
            })
        }),
        deleteTask: builder.mutation<DeleteTaskResponse, DeleteTaskPayload>({
            query: (body) => ({
                url: '/timesheets/tasks',
                method: 'DELETE',
                body
            })
        })
    })
});

export const {
    useGetTimesheetsReportsMutation,
    useGetTimesheetsTasksMutation,
    useCreateTimesheetMutation,
    useUpdateTimesheetMutation,
    useDeleteTaskMutation
} = timesheetsApi;
